export const Delete = (props) => (
  <svg
    style={{ ...props?.style }}
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M14.85 15.75H18.65V17.625H14.85V15.75ZM14.85 8.25H21.5V10.125H14.85V8.25ZM14.85 12H20.55V13.875H14.85V12ZM3.45 17.625C3.45 18.6562 4.305 19.5 5.35 19.5H11.05C12.095 19.5 12.95 18.6562 12.95 17.625V8.25H3.45V17.625ZM13.9 5.4375H11.05L10.1 4.5H6.3L5.35 5.4375H2.5V7.3125H13.9V5.4375Z'
      fill='inherit'
    />
  </svg>
);

export const DeleteUploadApk = (props) => (
  <svg
    style={{ ...props?.style }}
    width='14'
    height='12'
    viewBox='0 0 14 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.00016 8.66675H11.6668V10.0001H9.00016V8.66675ZM9.00016 3.33341H13.6668V4.66675H9.00016V3.33341ZM9.00016 6.00008H13.0002V7.33341H9.00016V6.00008ZM1.00016 10.0001C1.00016 10.7334 1.60016 11.3334 2.3335 11.3334H6.3335C7.06683 11.3334 7.66683 10.7334 7.66683 10.0001V3.33341H1.00016V10.0001ZM8.3335 1.33341H6.3335L5.66683 0.666748H3.00016L2.3335 1.33341H0.333496V2.66675H8.3335V1.33341Z'
      fill='inherit'
    />
  </svg>
);
